import type { BrandMeta } from "../types";

export const meta: BrandMeta = {
    id: "askethos",
    name: "Ask Ethos",
    title: "Ask Ethos",
    description: "An AI-enabled chatbot providing federal ethics guidance and resources",
    themeColor: "#256482",
    fontsHref:
        "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100..700;1,100..700&family=IBM+Plex+Serif:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap",
    icons: {
        appleTouch: "favicon.svg",
        pwaAny: "favicon.svg",
        pwaMaskable: "favicon.svg"
    }
};
